import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=b6e73304&scoped=true"
import script from "./comments.vue?vue&type=script&lang=js"
export * from "./comments.vue?vue&type=script&lang=js"
import style0 from "./comments.vue?vue&type=style&index=0&id=b6e73304&prod&scoped=true&lang=css"
import style1 from "./comments.vue?vue&type=style&index=1&id=b6e73304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e73304",
  null
  
)

export default component.exports